import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "learning-standards",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "./modules/Module"
        ),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "Teacher/modules/TeacherModule"
        ),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "Administrator/modules/AdministratorModule"
        ),
      ]).then(
        ([
          importedModule0,
          importedModule1,
          importedModule2,
          importedModule3,
          importedModule4,
        ]) => {
          const component = importedModule0.default;
          const reducer = importedModule1.default;
          const multiLevelNodeEditorReducer = importedModule2.default;
          const teacherReducer = importedModule3.default;
          const administratorReducer = importedModule4.default;
          injectReducer(store, {
            key: "learningStandards",
            reducer,
          });
          injectReducer(store, {
            key: "multiLevelNodeEditor",
            reducer: multiLevelNodeEditorReducer,
          });
          injectReducer(store, {
            key: "teacher",
            reducer: teacherReducer,
          });
          injectReducer(store, {
            key: "administrator",
            reducer: administratorReducer,
          });
          return component;
        }
      )
    //.catch(err => {
    //   throw err;
    // })
  ),
});
